import moment from 'moment'
const date = moment().subtract(335, 'days').format('MMMM Do, YYYY')

export default [
  {
    component: 'div',
    class: 'row',
    name: 'name',
    children: [
      {
        name: 'firstName',
        label: 'First Name *',
        validation: 'required',
        validationMessages: {
          required: 'First name is required.'
        }
      },
      {
        name: 'lastName',
        label: 'Last Name *',
        validation: 'required',
        validationMessages: {
          required: 'Last name is required.'
        }
      }
    ]
  },
  {
    component: 'div',
    class: 'row',
    name: 'emailPhone',
    children: [
      {
        name: 'email',
        label: 'Email *',
        validation: 'required|email'
      },
      {
        name: 'phone',
        label: 'Phone *',
        validation: 'required'
      }
    ]
  },
  {
    name: 'businessNameCoinventors',
    component: 'div',
    class: 'row',
    children: [
      {
        name: 'businessName',
        label: 'Name of business entity'
      },
      {
        name: 'coinventors',
        label: 'Co-inventor(s) if any'
      }
    ]
  },
  {
    repeatable: false,
    name: 'addresses',
    component: 'div',
    class: 'field-group',
    children: [
      {
        name: 'address1',
        label: 'Street Address Line 1 *',
        validation: 'required',
        validationMessages: {
          required: 'Street address is required.'
        }
      },
      {
        name: 'address2',
        label: 'Street Address Line 2'
      },
      {
        name: 'city',
        label: 'City *',
        validation: 'required'
      },
      {
        component: 'div',
        class: 'row',
        children: [
          {
            name: 'state',
            type: 'select',
            label: 'State *',
            options: {
              '': 'Select State',
              'AL': 'Alabama',
              'AK': 'Alaska',
              'AZ': 'Arizona',
              'AR': 'Arkansas',
              'CA': 'California',
              'CO': 'Colorado',
              'CT': 'Connecticut',
              'DE': 'Delaware',
              'DC': 'District Of Columbia',
              'FL': 'Florida',
              'GA': 'Georgia',
              'HI': 'Hawaii',
              'ID': 'Idaho',
              'IL': 'Illinois',
              'IN': 'Indiana',
              'IA': 'Iowa',
              'KS': 'Kansas',
              'KY': 'Kentucky',
              'LA': 'Louisiana',
              'ME': 'Maine',
              'MD': 'Maryland',
              'MA': 'Massachusetts',
              'MI': 'Michigan',
              'MN': 'Minnesota',
              'MS': 'Mississippi',
              'MO': 'Missouri',
              'MT': 'Montana',
              'NE': 'Nebraska',
              'NV': 'Nevada',
              'NH': 'New Hampshire',
              'NJ': 'New Jersey',
              'NM': 'New Mexico',
              'NY': 'New York',
              'NC': 'North Carolina',
              'ND': 'North Dakota',
              'OH': 'Ohio',
              'OK': 'Oklahoma',
              'OR': 'Oregon',
              'PA': 'Pennsylvania',
              'RI': 'Rhode Island',
              'SC': 'South Carolina',
              'SD': 'South Dakota',
              'TN': 'Tennessee',
              'TX': 'Texas',
              'UT': 'Utah',
              'VT': 'Vermont',
              'VA': 'Virginia',
              'WA': 'Washington',
              'WV': 'West Virginia',
              'WI': 'Wisconsin',
              'WY': 'Wyoming'
            },
            validation: 'required'
          },
          {
            name: 'zip',
            label: 'Zip Code *',
            validation: 'required|matches:/^[0-9]{5}(-[0-9]{4})?$/',
            validationMessages: {
              required: 'Zip code is required.',
              matches: 'Zip code is not correct format.'
            }
          },
        ]
      }
    ]
  },
  {
    name: 'knownCompetitors',
    label: 'Known Competitors (if any)',
    help: 'Please do not search for competitors in the field, only enter those you are aware of at this time'
  },
  {
    component: 'div',
    class: 'row',
    name: 'passwords',
    children: [
      {
        type: 'password',
        name: 'password',
        label: 'Create a password *',
        validation: '^required|min:6,length'
      },
      {
        type: 'password',
        name: 'password_confirm',
        label: 'Confirm password *',
        validation: '^required|confirm|min:6,length',
        validationMessages: {
          required: 'Password confirmation is required',
          confirm: 'Passwords must match',
          min: 'Password must be at least 6 characters long'
        }
      }
    ]
  },
  {
    repeatable: false,
    name: 'certifications',
    component: 'div',
    class: 'field-group certifications',
    children: [
      {
        component: 'h4',
        name: 'certsLabel',
        children: 'Inventor Certifications *'
      },
      {
        name: 'certification1',
        type: 'radio',
        options: {
          'neverDisclosed': 'I certify that my invention has never been disclosed publicly, or',
          'neverDisclosedPrior': `I certify that my invention was not disclosed publicly prior to ${date}, or`,
          'disclosed': `My invention was disclosed more than 11 months ago, prior to ${date}`,
        },
        validation: 'required|not:disclosed',
        validationMessages: {
          required: 'This certification is required',
          not: 'Note: The attorney will need to discuss the date and circumstances with you during your consultation to determine if a provisional application may lawfully be filed.'
        }
      },
      {
        component: 'hr',
        name: 'sep',
        class: 'separator'
      },
      {
        name: 'certification2',
        type: 'radio',
        options: {
          'neverSold': 'I certify that my invention has never been sold or offered for sale, or',
          'neverSoldPrior': `I certify that my invention was not sold or offered for sale prior to ${date}, or`,
          'sold': `My invention was sold or offered for sale more than 11 months ago, prior to ${date}`,
        },
        validation: 'optional|not:sold',
        validationMessages: {
          required: 'This certification is required',
          not: 'Note: The attorney will need to discuss the date and circumstances with you during your consultation to determine if a provisional application may lawfully be filed.'
        }
      },
    ]
  },
]